import {Component, Input, OnInit} from '@angular/core';
import {NgxSpinnerService} from "ngx-spinner";
import {GrantApplicationService} from "../../../../services/grantApplication.service";
import {
  GrantApplicationSubmittedReportResponse
} from "../../../../models/grantApplication/grantApplicationSubmittedReportResponse";
import { Router } from '@angular/router';
import {GrantApplicationStatus} from "../application-detail.component";

@Component({
  selector: 'app-report-due',
  templateUrl: './report-due.component.html',
  styleUrls: ['./report-due.component.scss']
})
export class ReportDueComponent implements OnInit{
  reportDue: GrantApplicationSubmittedReportResponse[] = [];
  @Input() applicationId:string="";
  @Input() projectId:string="";
  @Input() isReadOnly: boolean = false;
  @Input() graintApplicationStaus!: GrantApplicationStatus;

  constructor(
    private spinner: NgxSpinnerService,
    private grantApplication: GrantApplicationService,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    if (this.graintApplicationStaus === 'Approved' || this.isReadOnly) {
      this.spinner.show();
      this.loadTasks(this.applicationId)
        .finally(() => this.spinner.hide());
    }
  }





  loadTasks(appId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.grantApplication.getReportDue(appId).subscribe({
        next: (response) => {
          this.reportDue = response.item?.filter(app => app.name !== 'Project Evaluation') || [];

          resolve();
        },
        error: (error) => {
          console.error('Error fetching tasks:', error);
          reject(error);
        },
      });
    });
  }

  navigateToSubmitReport(app: GrantApplicationSubmittedReportResponse) {
    if (app.refId) {
      this.spinner.show();
      this.grantApplication.getRegardingReport(app.refId).subscribe({
        next: (response) => {
          if (response.result && response.item) {
            this.router.navigate([`/applications/report/${response.item}`]);
          } else {
            console.error('Cannot navigate: ', response.messages);
          }
          this.spinner.hide();
        },
        error: (error) => {
          console.error('Error fetching tasks:', error);
          this.spinner.hide();
        },
      });
    }
  }






}
